interface CaretRightIconProps {
  color?: string;
  ariaName?: string;
}

export const CaretRightIcon: React.FC<CaretRightIconProps> = ({ color = '#111111', ariaName }) => {
  return (
    <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>{ariaName}</title>
      <path d="M1 1L7 7.17143L1 13" stroke={color} strokeWidth="2" />
    </svg>
  );
};
